import Vue from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'

import App from '../App.vue'
import store from '../store'
import router from '../router'
import { setupRouter } from '../router/guards.js'
import idleLogout from '../services/idleLogout.js'

// Plugins
import '../plugins/axios.js'
import '../plugins/fontAwesome.js'
import '../plugins/bootstrapVue.js'
import '../plugins/veeValidate.js'
import '../plugins/toggleButton.js'
import '../plugins/stimulus.js'

// Global vue filters
import './filters.js'

Vue.config.devtools = process.env.NODE_ENV === 'development'
Vue.config.productionTip = false
Vue.use(TurbolinksAdapter)

let vueInstance = null

export function mountVueApp() {
  const el = document.getElementById('main-app')
  if (!el) return

  if (vueInstance) {
    vueInstance.$destroy()
    vueInstance = null
  }

  const { currentUser, roles, settings } = parseAppData(el)

  idleLogout()
  setupRouter(router, store, roles)

  vueInstance =new Vue({
    el,
    store,
    router,
    template: '<App />',
    components: { App },
    created() {
      store.commit('initData', { currentUser, roles, settings })
    }
  })
}

function parseAppData(el) {
  try {
    return {
      currentUser: JSON.parse(el.dataset.currentUser),
      roles:       JSON.parse(el.dataset.roles),
      settings:    JSON.parse(el.dataset.settings)
    }
  } catch (e) {
    console.error('[vueApp] Failed to parse app data from DOM:', e)
    throw e
  }
}
